import HB from '../hb/hb'
import dfp_config from './dfp_config';
import log from '/js/common/Logger';
import Utils from '/js/common/Utils';
import _ from 'lodash';
import {E_BIDS_READY} from '../hb/hb_events';

export default class Dfp {

  constructor(dfpAccountId = dfp_config.id, isLazyLoad = false, hbEnabled = true) {
    this.isFirstTime = true;
    this.refreshLocks = {};
    this.id = dfpAccountId;
    this.dfpDisplayTags = [];
    this.idsToSlots = {};
    this.idsToAdUnitNames = {};
    this.idsToAdUnits = {};
    this.idsToRefreshCounters = {};
    this.isLazyLoad = isLazyLoad;
    this.isHB = hbEnabled;
    this.placements = {};
  }

  setPlacements(placements) {
    this.placements = placements;
  }

  async init() {
    if (this.isHB) {
      this.hb = new HB();
    }
    // Utils.loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js');
    window.googletag = window.googletag || {};
    googletag.cmd = googletag.cmd || [];
    const self = this;
    googletag.cmd.push(function() {
      if (self.isHB) {
        googletag.pubads().disableInitialLoad();
      }
      if (dfp_config.is_coppa) {
        googletag.pubads().setTagForChildDirectedTreatment(1);
      }
      googletag.pubads().collapseEmptyDivs();
      googletag.cmd.push(function() {
        const events = ['slotRequested', 'slotResponseReceived','slotOnload','slotRenderEnded']
        events.forEach(eventName => {
          googletag.pubads().addEventListener(eventName, (e) => {
            log.debug(`DFP Event: ${eventName}`, e);
            // const adUnitName = _.last(e.slot.getAdUnitPath().split('/'));
            // if (e.hasOwnProperty('sourceAgnosticLineItemId')) {
            //   const lineItem = e.sourceAgnosticLineItemId || 'no fill'
            //   AdsAnalytics.sendEvent(`DFP_${adUnitName}`, eventName, ''+lineItem);
            // } else {
            //   AdsAnalytics.sendEvent(`DFP_${adUnitName}`, eventName)
            // }
          });
        });
        googletag.pubads().addEventListener('slotRenderEnded', reportFirstAdTiming);
        function reportFirstAdTiming(e) {
          const adUnitName = _.last(e.slot.getAdUnitPath().split('/'));
          //RTGoogleAnalytics.sendTiming('Ads', 'dfp_first_ad', adUnitName);
        }
      })
    });
  }


  // * => []
  _getPlacementElementsFromPage() {
    let placementEls = document.querySelectorAll('.pomad-placement');
    placementEls =
    _.forEach(
      _.filter(placementEls, currEl => currEl.dataset.pmdPlacementLoaded !== '1')
      , currEl => {
          if (_.isEmpty(currEl.id)) {
            currEl.id = _.uniqueId('pmd-gen-place-'+currEl.dataset.pmdPlacementName+'-');
          }
    });


    return placementEls;
  }

  displaySingleAd(placementEl, retry = true) {
    if (placementEl && this.idsToSlots[placementEl.id]) {
      googletag.cmd.push(function() {
        googletag.display(placementEl.id);
        placementEl.dataset.pmdDisplay = '1';
      });
    } else if (retry) {
      this.fillPlacementsWithAds();
      this.displaySingleAd(placementEl, false);
    }

  }

  /**
   * Refreshes by name if timeout hasn't expired
   * @param id
   */
  refreshByAdUnitName(name, overrideLock = false, targetingKeyValMap = {}) {
    log.debug(`refreshing ${name}...`);
    const namesToIds = _.invert(this.idsToAdUnitNames);
    const id = namesToIds[name];
    this.refreshById(id, overrideLock, targetingKeyValMap)
  }


  /**
   * Refreshes by id if timeout hasn't expired
   * @param id
   */
  refreshById(id, overrideLock = false, targetingKeyValMap = {}) {
    log.debug(`refreshing ${id}...`);
    if (dfp_config.refresh_timeout < 0 && !overrideLock) {
      log.debug(`cannot refresh id ${id} - refresh disabled`);
      return;
    }
    const locked = this.refreshLocks[id] === true;
    if (locked && !overrideLock) {
      log.debug(`cannot refresh (id ${id} is currently locked)`);
      return;
    }
    const slot = this.idsToSlots[id]
    const self = this;
    if (slot) {
      _.isNumber(this.idsToRefreshCounters[id]) ? this.idsToRefreshCounters[id]++ : this.idsToRefreshCounters[id] = 1;
      googletag.cmd.push(function() {
        targetingKeyValMap['refresh_count']=self.idsToRefreshCounters[id];
        _.forEach(targetingKeyValMap, (val, key) => {
          slot.setTargeting(key, val);
        });
        if (self.isHB) {
          self.hb.refreshBid(slot);
        } else {
          googletag.pubads().refresh([slot]);
        }
        self.lockRefreshes(id);
        //AdsAnalytics.trackAdUnit(self.idsToAdUnitNames[id], self.idsToRefreshCounters[id])
      })
    } else {
      log.warn(`could not refresh ${id}, slot not found!`);
    }
  }

  lockRefreshes(id) {
    log.debug(`locking ${id} for ${dfp_config.refresh_timeout}ms`)
    this.refreshLocks[id] = true;
    const self = this;
    setTimeout(function() {
      self.refreshLocks[id] = false
    }, dfp_config.refresh_timeout)
  }

  displayRemainingAds() {
    const self = this;
    googletag.cmd.push(function() {
      while (self.dfpDisplayTags.length > 0) {
        let id = self.dfpDisplayTags.shift();
        googletag.display(id);
        //placementEl.dataset.pmdDisplay = '1';
        self.lockRefreshes(id);
        //AdsAnalytics.trackAdUnit(self.idsToAdUnitNames[id])
      }
    });
  }

  enableServices() {
    const self = this;
    googletag.cmd.push(function() {
      _.forEach(dfp_config.targetingMap, (val, key) => {
        googletag.pubads().setTargeting(key, val)
      });
      if (!self.isLazyLoad) {
        googletag.pubads().enableSingleRequest();
      }
      googletag.enableServices();
    });
  }

  fillPlacementsWithAds() {
    let placementEls = this._getPlacementElementsFromPage();
    if (_.isEmpty(placementEls)) {
      log.debug('no placements found on page, skipping...');
      return;
    }
    log.debug('found these placements on page: ', placementEls)

    const currCreatedAdUnits = [];
    placementEls.forEach(el => {
      let name = el.dataset.pmdPlacementName;
      if (!_.isEmpty(_.result(this.placements , `[${name}].ad_units`, []))) {
        let currUnit = this.placements[name].ad_units.shift();
        if (_.isEmpty(currUnit.sizes)) { //check that unit has valid size array
          log.debug(`${currUnit.name} - no valid sizes, skipping`)
        }
        else if (!currUnit.hasAlreadyCreatedElement) { //check if not already created
          currUnit.hasAlreadyCreatedElement = true;
          this.createDfpAdEl(currUnit, el);
          currCreatedAdUnits.push(currUnit);
        }
      }
    });
    if (this.isHB) {
      const self = this;
      if (this.isFirstTime) {
        this.isFirstTime = false;
        window.addEventListener(E_BIDS_READY, () => {
          this.enableServices()
          googletag.cmd.push(function() {
            googletag.pubads().refresh();
          });
        });
        const adUnits = this.hb.prepareAdUnits(currCreatedAdUnits)
        this.hb.createWithUnits(adUnits);
      } else {
        googletag.cmd.push(() => {
          self.hb.refreshBids(_.map(currCreatedAdUnits, adUnit => self.idsToSlots[adUnit.selector]), currCreatedAdUnits)
        });
      }
    } else {
      if (this.isFirstTime) {
        this.isFirstTime = false;
        this.enableServices();
      }
      if (!this.isLazyLoad) {
        this.displayRemainingAds();
      }
    }

  }

  createDfpAdEl(adUnit, el) {
    const self = this;
    adUnit.selector = el.id;
    self.idsToAdUnitNames[el.id] = adUnit.name;
    self.idsToAdUnits[el.id] = adUnit;
    googletag.cmd.push(function() {
      el.dataset.pmdPlacementLoaded = 1;
      el.dataset.pmdPlacementType = 'DFP';
      el.dataset.pmdAdUnitName = adUnit.name;
      log.debug(`creating ad unit ${adUnit.name} in element #${el.id} with sizes:`, adUnit.sizes)
      let slot = googletag.defineSlot('/' + self.id + '/' + adUnit.name, adUnit.sizes, el.id)
        .addService(googletag.pubads())
        .setTargeting('refresh_count', '0');
      self.idsToSlots[el.id] = slot;
      self.dfpDisplayTags.push(el.id);
    });
  }


}
